// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vPWV","type":"styles_type__hd0-r","choices":"styles_choices__23mJa"};